import { render } from "./Main.vue?vue&type=template&id=b6a30afe&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=b6a30afe&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=b6a30afe&lang=css"
script.render = render
script.__scopeId = "data-v-b6a30afe"

export default script